<style lang="scss" scoped>
@import "core";

.bc-banner-carousel {
  @include bcb-reset;
  width: 100%;
  overflow: visible;

  &--exist {
    min-height: 1px;
  }

  &--fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: rgba(255, 255, 255, .8);
  }

  &__container {
    width: 100%;
    overflow: visible;
    position: relative;
    margin: 0 auto!important;
  }

  &__slider {
    position: absolute;
    top: 0;
    left: 0;
    transition-property: margin;
    transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  &__item {
    position: absolute;
    top: 0;
    cursor: pointer;
    transition: opacity .35s;

    &:hover,
    &:focus {
      opacity: .9;
    }

    a {
      // pointer-events: none;
      display: block;
      width: 100%;
      height: 100%;
    }

    img {
      pointer-events: none;
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__btn {
    z-index: 2;
    $my-width: 20px;
    $my-height: 32px;
    $my-btn-padding: 20px;
    $my-btn-color: #f0f0f0;
    $my-round: 3px;
    $my-tri-color: #666;
    @include btn-base($display: block, $position: absolute);
    width: $my-width + $my-btn-padding;
    height: 100%;

    & > span {
      @include btn-base($position: absolute);
      z-index: 1;
      padding: 0;
      margin: 0;
      width: $my-width;
      height: $my-height;
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
      background-color: $my-btn-color;
      top: 50%;
      margin-top: -16px;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.4);
      transition: background-color .35s;

      &:after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        z-index: 1;
        top: 50%;
        left: 50%;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        border-top: solid 2px $my-tri-color;
        border-right: solid 2px $my-tri-color;
        transform-origin: center, center;
      }
    }

    &:hover,
    &:focus {
      & > span {
        background-color: darken($my-btn-color, 10%);
      }
    }

    &:active {
      & > span {
        background-color: darken($my-btn-color, 15%);
      }
    }

    &-prev {
      left: 0;

      & > span {
        left: 0;
        border-radius: 0 $my-round $my-round 0;

        &:after {
          transform: rotate(-135deg);
          margin-left: -2px;
        }
      }
    }

    &-next {
      right: 0;

      & > span {
        right: 0;
        border-radius: $my-round 0 0 $my-round;

        &:after {
          transform: rotate(45deg);
          margin-left: -4px;
        }
      }
    }
  }
}

.bc-banner-carousel__scroller {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bc-banner-carousel__close {
  @include close-icon;
  right: -5px;
  top: -30px;
}
</style>

<template>
  <div :class="classes" :style="styles" v-show="isExist">
    <div :class="containerClasses" :style="containerStyles" ref="container">
      <div class="bc-banner-carousel__scroller">
        <a class="bc-banner-carousel__btn bc-banner-carousel__btn-prev" href="javascript:void(0);" @click.stop="prev"><span>前へ</span></a>
        <ul
          :class="sliderClasses"
          :style="sliderStyles"
          v-if="isExist"
        >
          <v-touch
            tag="li"
            :class="itemClasses"
            :style="item.style"
            v-for="(item, index) in computedItems"
            :key="index"
            @panstart="onPanStart"
            @panmove="onPanMove"
            @panend="onPanEnd"
            @pancancel="onPanEnd"
            :pan-options="{direction: 'horizontal', threshold: 0}"
          >
            <a
              :href="item[`url_${mq}`]"
              :target="item.blankWindow"
              @click="onItemClick(item, $event)"
              tabindex="-1"
              draggable="false"
              @dragstart.prevent
              @dragmove.prevent
              @dragend.prevent
            >
              <img :src="item[`fileName_${mq}`]" alt="" draggable="false">
            </a>
          </v-touch>
        </ul>
        <a class="bc-banner-carousel__btn bc-banner-carousel__btn-next" href="javascript:void(0);" @click.stop="next($event)"><span>次へ</span></a>
      </div>
      <button
        v-if="fixed"
        class="bc-banner-carousel__close"
        type="button"
        @click.stop="fixedDestroy"
      ><i>閉じる</i></button>
    </div>
  </div>
</template>

<script>
import bannerMixin from '../mixins/banner';



const SLIDER_TRANSITION_DURATION     = 350;
const FIXED_ACTIVE_FIRST_JUDGE_DELAY = 500;
const FIXED_ACTIVE_DURATION          = 500;
const CLICK_CANCEL_INTERVAL          = 300;



export default {
  name: 'bc-banner-carousel',

  mixins: [bannerMixin],

  props: {
    size: {
      type: Object,
      required: true,
    },
    fixed: Boolean,
    zIndex: {
      type: [Number, String],
      default: 5001,
    },
    maxContainerWidth: {
      type: [Number, String],
      default: 950,
    },
    padding: {
      type: [Number, String, Object],
      default: () => { return {pc: 10, sp: 0} },
    },
    itemMargin: {
      type: [Number, String],
      default: 10,
    },
    backgroundColor: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      needs: 5,
      forceHidden: true,
      containerWidth: null,
      sliderLeft: 0,
      sliderDuration: 0,
      sliderPanAmmount: 0,
      sliderTransitionTimerId: null,
      rotationTimerId: null,
      nowPaning: false,
      fixedActive: false,
      fixedVisibility: false,
      paningTimerId: null,
    }
  },

  computed: {
    isFixedHide() { return this.fixed && !this.fixedActive },
    classes() {
      return {
        [this.$options.name]: true,
        [`${this.$options.name}--exist`]: this.isExist,
        [`${this.$options.name}--fixed`]: this.fixed,
        [`${this.$options.name}--fixed-hide`]: this.isFixedHide,
      }
    },
    styles() {
      return {
        background: this.backgroundColor ? this.backgroundColor : null,
        height: `${this.computedSize.height + this.computedPadding.vertical * 2}px`,
        padding: `${this.computedPadding.vertical}px`,
        zIndex: this.fixed && this.zIndex ? this.zIndex : null,
        bottom: this.isFixedHide ? `-${this.fullHeight}px` : null,
        opacity: (this.fixed && !this.fixedVisibility) || this.forceHidden ? 0 : 1,
        transition: this.fixed ? `bottom ${FIXED_ACTIVE_DURATION}ms` : null,
      };
    },
    fullHeight() {
      return this.computedPadding.vertical * 2 + this.computedSize.height + 32;
    },
    containerClasses() {
      return {
        [`${this.$options.name}__container`]: true,
      }
    },
    containerStyles() {
      return {
        width: this.fixed && this.containerWidth ? `${this.containerWidth}px` : null,
        height: `${this.computedSize.height}px`,
      }
    },
    sliderClasses() {
      return {
        [`${this.$options.name}__slider`]: true,
        [`${this.$options.name}__slider--transition`]: this.sliderLeft !== 0,
      }
    },
    sliderStyles() {
      return {
        width: `${this.computedItemWidth * this.needs}px`,
        height: `${this.computedSize.height}px`,
        marginLeft: `${this.sliderLeft + this.sliderPanAmmount}px`,
        transitionDuration: this.sliderDuration !== 0 ? `${this.sliderDuration}ms` : null,
      }
    },
    itemClasses() {
      return {
        [`${this.$options.name}__item`]: true,
      }
    },
    needsHalf() { return Math.floor(this.needs / 2) },
    offsetLeft() {
      return (this.containerWidth - this.computedItemWidth) / 2 - (this.needsHalf * this.computedItemWidth);
    },
    computedPaddingMqMap() {
      let padding = this.padding;
      if (padding === null || typeof padding !== 'object' || !padding.pc) {
        padding = {
          pc: padding,
          sp: padding,
        }
      }
      ['pc', 'sp'].forEach(key => {
        if (typeof padding[key] !== 'object') padding[key] = {horizontal: padding[key], vertical: padding[key]};
        padding[key].horizontal = parseInt(padding[key].horizontal, 10);
        padding[key].vertical   = parseInt(padding[key].vertical, 10);
      });
      return padding;
    },
    computedPadding() {
      return this.computedPaddingMqMap[this.mq];
    },
    computedSize() { return this.size[this.mq] },
    computedItemMargin() { return parseInt(this.itemMargin, 10) },
    computedItemWidth() {
      const size = this.computedSize;
      return size.width + this.computedItemMargin;
    },
    computedItemStyle() {
      const size = this.computedSize;
      return {
        width: this.computedItemWidth + 'px',
        height: size.height + 'px',
        padding: '0 ' + this.computedItemMargin / 2 + 'px',
      }
    },
    computedItems() {
      const items  = [];
      const _items = this.items;
      const startIndex = this.index - this.needsHalf;
      const size       = this.computedSize;
      const style      = this.computedItemStyle;

      for (let i = 0; i < this.needs; i++) {
        let index = i + startIndex;
        if (index < 0) {
          index = _items.length + index;
        } else {
          index = index % _items.length;
        }

        items.push(Object.assign({
          style: Object.assign({
            left: `${i * this.computedItemWidth + this.offsetLeft}px`,
          }, style),
        }, _items[index]));
      }
      return items;
    },
    computedMaxContainerWidth() {
      if (!this.fixed || !this.maxContainerWidth) return null;
      return parseInt(this.maxContainerWidth, 10) || null;
    },
    nowSliderTransition() { return this.sliderTransitionTimerId !== null },
    isDisabled() { return this.nowSliderTransition },
    nowRotation() { return this.rotationTimerId !== null},
  },

  watch: {
    isFixedHide() {
      if (this.isFixedHide) {
        this.fixedVisibilityTimer = setTimeout(() => {
          this.fixedVisibility = false;
        }, FIXED_ACTIVE_DURATION);
      } else {
        this.clearFixedVisibiltyTymer();
        this.fixedVisibility = true;
      }
    },
  },

  methods: {
    fixedDestroy() {
      this.fixedActive = false;
      this.reset();
    },

    clearFixedVisibiltyTymer() {
      if (this.fixedVisibilityTimer !== null) {
        clearTimeout(this.fixedVisibilityTimer);
        this.fixedVisibilityTimer = null;
      }
    },

    prev(e) {
      if (e) this.$bcb.blurActiveElement();
      if (this.isDisabled) return;
      this.slideIndex(-1);
    },
    next(e) {
      if (e) this.$bcb.blurActiveElement();
      if (this.isDisabled) return;
      this.slideIndex(1);
    },

    async slideIndex(ammount, duration = SLIDER_TRANSITION_DURATION) {
      if (this.isDisabled) return;

      this.stopRotation();
      this.sliderDuration = duration;

      let nextIndex = this.index + ammount;
      if (nextIndex >= this.count) {
        nextIndex -= this.count;
      } else if (nextIndex < 0) {
        nextIndex += this.count;
      }

      if (ammount !== 0) {
        const moveCount = this.index + ammount - this.index;
        const moveWidth = this.computedItemWidth * moveCount;
        this.sliderLeft = -moveWidth;
      }

      await new Promise((resolve, reject) => {
        this.sliderTransitionTimerId = setTimeout(() => {
          requestAnimationFrame(() => {
            this.index = nextIndex;
            this.startRotation();
            this.clearSliderTransitionTimer();
            resolve();
          });
        }, SLIDER_TRANSITION_DURATION);
      });
    },

    clearSliderTransitionTimer() {
      if (this.nowSliderTransition) {
        clearTimeout(this.sliderTransitionTimerId);
        this.sliderTransitionTimerId = null;
        this.sliderLeft = 0;
        this.sliderDuration = 0;
      }
    },

    updateContainerWidth() {
      let width = this.$el.clientWidth - this.computedPadding.horizontal * 2;
      if (this.computedMaxContainerWidth && width > this.computedMaxContainerWidth) {
        width = this.computedMaxContainerWidth;
      }
      this.containerWidth = width;

      if (this.forceHidden) {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.forceHidden = false;
          });
        });
      }
    },
    startResizeListener() {
      if (!this.isExist) return;
      const onResize = e => {
        this.updateContainerWidth();
      }

      window.addEventListener('resize', onResize, false);
      window.addEventListener('orientationchange', onResize, false);

      this._removeResizeListener = () => {
        window.removeEventListener('resize', onResize, false);
        window.removeEventListener('orientationchange', onResize, false);
      }
    },
    stopResizeListener() {
      if (this._removeResizeListener) {
        this._removeResizeListener();
        delete this._removeResizeListener;
      }
    },
    clearPaningTimer() {
      if (this.paningTimerId !== null) {
        clearTimeout(this.paningTimerId);
        this.paningTimerId = null;
      }
    },
    onPanStart(e) {
      this.nowPaning = true;
      this.clickDisabled = true;
      this.stopRotation();
    },
    onPanMove(e) {
      this.sliderPanAmmount = e.deltaX;
    },
    async onPanEnd(e) {
      this.nowPaning = false;
      this.clearPaningTimer();
      this.paningTimerId = setTimeout(() => {
        this.clearPaningTimer();
        this.clickDisabled = false;
      }, CLICK_CANCEL_INTERVAL)
      const slideAmmount = Math.round(this.sliderPanAmmount / this.computedItemWidth) * -1;
      this.sliderPanAmmount = 0;
      await this.slideIndex(slideAmmount);
      this.startRotation();
    },
    startRotation() {
      if (!this.isExist) return;
      if (this.isPause) {
        return;
      }
      this.stopRotation();
      this.rotationTimerId = setInterval(() => {
        this.next();
      }, this.rotateInterval);
    },
    stopRotation() {
      if (this.rotationTimerId !== null) {
        clearInterval(this.rotationTimerId);
        this.rotationTimerId = null;
      }
    },
    reset() {
      this.clearSliderTransitionTimer();
      this.stopResizeListener();
      this.stopRotation();
      this.removeHasExpelFixedChangeListener();
      this.removeWindowScrollListener();
    },
    start() {
      this.updateContainerWidth();
      this.startResizeListener();
      this.startRotation();
      this.registHasExpelFixedChangeListener();
      this.registWindowScrollListener();
    },
    pauseAfter() {
      this.stopResizeListener();
      this.stopRotation();
    },
    resumeAfter() {
      this.updateContainerWidth();
      this.startResizeListener();
      this.startRotation();
    },
    beforeItemsUpdate() {
      this.reset();
    },
    afterItemsUpdate() {
      this.start();
    },
    toggleByRootHasExpelFixed() {
      if (!this.fixed) return;
      if (this.$root.hasExpelFixed) {
        this.hideFixed();
      } else {
        this.showFixed();
      }
    },
    hideFixed() {
      this.fixedActive = false;

      setTimeout(() => {
        this.updateVisible();
      }, FIXED_ACTIVE_DURATION);
    },
    showFixed() {
      this.updateContainerWidth();
      this.fixedActive = true;

      setTimeout(() => {
        this.updateVisible();
      }, FIXED_ACTIVE_DURATION);
    },
    registHasExpelFixedChangeListener() {
      if (!this.fixed) return;
      this._onHasExpelFixedChange = () => {
        this.toggleByRootHasExpelFixed();
      }
      this.$root.$on('hasExpelFixedChange', this._onHasExpelFixedChange);
      setTimeout(() => {
        if (this._onHasExpelFixedChange) {
          this._onHasExpelFixedChange();
        }
      }, FIXED_ACTIVE_FIRST_JUDGE_DELAY);
    },
    removeHasExpelFixedChangeListener() {
      if (!this.fixed || !this._onHasExpelFixedChange) return;
      this.$root.$off('hasExpelFixedChange', this._onHasExpelFixedChange);
      delete this._onHasExpelFixedChange;
    },
    registWindowScrollListener() {
      if (!this.fixed) return;
      this.$window.on(`scrollStart.${this._bcb_uid_}--carousel`, () => {
        this.hideFixed();
      });

      this.$window.on(`scrollEnd.${this._bcb_uid_}--carousel`, () => {
        this.toggleByRootHasExpelFixed();
      });
    },
    removeWindowScrollListener() {
      if (!this.fixed) return;
      this.$window.off(`.${this._bcb_uid_}--carousel`);
    },
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
    this.reset();
    this.clearFixedVisibiltyTymer();
  },
}

</script>



// WEBPACK FOOTER //
// Carousel.vue?2371f53a